import React from "react";

const Logout = () => <h2>Thanks for visiting. Come back soon</h2>;

export default Logout;
